import React, { useEffect, useState } from "react";
import { Switch } from "@design-system/Switch/Switch";
import styles from "./PlaygroundSlowMotionToggle.module.scss";

const SLOW_MOTION_ATTRIBUTE = "data-playground-slow-motion";

/**
 * Playground-only switch that multiplies the motion duration tokens by 5 so
 * transitions can be inspected. The override lives on the root element while
 * the switch is on and is removed when it turns off or the page unmounts.
 */
export const PlaygroundSlowMotionToggle = () => {
    const [isSlowMotion, setIsSlowMotion] = useState(false);

    useEffect(() => {
        if (!isSlowMotion) {
            return;
        }

        const root = document.documentElement;
        root.setAttribute(SLOW_MOTION_ATTRIBUTE, "");

        return () => root.removeAttribute(SLOW_MOTION_ATTRIBUTE);
    }, [isSlowMotion]);

    return (
        <div className={styles.toggleRow}>
            <Switch
                checked={isSlowMotion}
                label="Slow motion ×5"
                onCheckedChange={(nextIsSlowMotion) =>
                    setIsSlowMotion(nextIsSlowMotion)
                }
            />
        </div>
    );
};
